<template>
  <main role="main">

    <section class="jumbotron text-center" style="width: 100%; display: flex; justify-content: center;">
      <div style="width: 90%; margin-top: -1cm">

        <div class="title1">游戏说明</div>

        <p class="lead text-muted m-3 text-left">
          您可以选择石头、剪刀、布三种策略开始游戏，您赢了即可赢得投注分数，而败北则会扣除投注分数。如果平局，则不会扣分。
        </p>

        <div class="title2">石头剪刀布</div>

        <div>
          <el-table :data="tips">
            <el-table-column label="您的选择" prop="radius"></el-table-column>
            <el-table-column label="最终结果" prop="count"></el-table-column>
          </el-table>
        </div>

        <hr>

        <div class="input-with-button-container">

          <el-select v-model="value" placeholder="请选择您的策略~">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
          <el-button type="primary" @click="startGame" size="medium">开始游戏</el-button>
        </div>

      <div>
        <p> </p>
        <hr>
        <p> </p>
      </div>


        <div class="title1">积分天梯榜 (前10)</div>
        <el-button type="primary" @click = "search" size="medium">更新排名</el-button>
        <div>
          <el-table :data="tableData">
            <el-table-column label="用户名" prop="name"></el-table-column>
            <el-table-column label="积分" prop="points"></el-table-column>
          </el-table>
        </div>
      </div>
    </section>
    <div class="album py-5 bg-light">
      <div class="container">
        <hr>

      </div>
    </div>

  </main>
</template>

<script>

  import TheCourse from "../components/the-course";
  export default {
    name: 'rockGame',
    components: {TheCourse},
    data: function () {
      return {
        value:'',
        options: [{
          value: '1',
          label: '石头'
        }, {
          value: '2',
          label: '剪刀'
        }, {
          value: '3',
          label: '布'
        }],
        tableData: [],
        tips:[],
        queryParams: {}, // 用于存储查询参数的对象
      }
    },
    created() {
      let _this = this;
      _this.getPointsRanking();
    },
    methods: {

      //更新排名
      search(){
        this.getPointsRanking()
      },

      startGame(){
        let _this = this;
        let loginMember = Tool.getLoginMember();
        if (Tool.isEmpty(loginMember)) {
          Toast.warning("请先登录");
          return;
        }

        _this.queryParams.memberId = loginMember.id;
        _this.queryParams.numberValue = this.value;
        console.log("queryParams:", _this.queryParams);
        _this.$ajax.post(process.env.VUE_APP_SERVER + '/business/web/pointGame/rockGame',
            _this.queryParams).then((response)=>{
          console.log("开始游戏：", response);
          _this.tips = response.data;
          },
        )
        },

      getPointsRanking() {
        let _this = this;
        _this.$ajax.get(process.env.VUE_APP_SERVER + '/business/web/pointGame/getPointsRanking').then((response)=>{
          console.log("积分排名：", response);
          _this.tableData = response.data;
        }).catch((response)=>{
          console.log("error：", response);
        })
      },

    }
  }
</script>

<style>
  .title1{
    margin-bottom: 2rem;
    color: #fafafa;
    letter-spacing: 0;
    text-shadow: 0px 1px 0px #999, 0px 2px 0px #888, 0px 3px 0px #777, 0px 4px 0px #666, 0px 5px 0px #555, 0px 6px 0px #444, 0px 7px 0px #333, 0px 8px 7px #001135;
    font-size: 2rem;
  }
  .title2{
    margin-bottom: 2rem;
    color: transparent;
    -webkit-text-stroke: 1px black;
    letter-spacing: 0.04em;
    font-size: 2rem;
  }
  .title {
    margin-bottom: 10px;
    font-size: 30px;
    color: #333;
    text-align: center;
  }

  .input-with-button-container {
    display: flex;
    align-items: center; /* 确保元素垂直居中对齐 */
    gap: 8px; /* 在两个元素间创建2字符（可以调整为所需的像素值）的间距 */
  }
</style>
